import script from "./ApprovalStatusCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ApprovalStatusCard.vue?vue&type=script&setup=true&lang=js"

import "./ApprovalStatusCard.vue?vue&type=style&index=0&id=67917d01&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67917d01"]])

export default __exports__